import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FuelcardService } from '../vdms_core/services/api/fuelcard.service';
import * as XLSX from 'xlsx';
import { AwsService } from '../../../providers/appsyncservice/aws.service';

@Component({
  selector: 'app-fuel-card-credit',
  templateUrl: './fuel-card-credit.component.html',
  styleUrls: ['./fuel-card-credit.component.css']
})
export class FuelCardCreditComponent implements OnInit {

  filteredFuelCardCreditList: any = [];
  filteredFuelCardCredit: any = [];
  pageSize: number = 10;
  activePage: number = 1;

  rnNumberFilterModel: any = new Array();
  cardNoFilterModel: any = new Array();

  rnNumberFilterData: any = [];
  cardNoFilterData: any = [];

  columnfilter = {
    rn_number: {
      singleSelection: false,
      idField: "rn_number",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN Number.",
    },
    fuel_card_number: {
      singleSelection: false,
      idField: "fuelcard.card_number",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Fuel Card Number.",
    }
  }

  sortKey: string = 'created_date';
  sortReverse: boolean = true;

  file: File;
  statusList = [];
  vendorList = [];
  uploadList = [];
  uploadStatus: number = 0;
  progresspercent: number = 0;
  displayValue: number = 0;
  arrayBuffer: any;
  sheetlength: number = 0;
  cnt: number = 1;
  enableUploadBtn: boolean = false;
  @ViewChild('uploadFile') uploadFile: ElementRef;
  @ViewChild('closeUploadModalBtn') closeuploadModalBtn: ElementRef;

  incomingfile(event) {
    this.uploadStatus = -1;
    this.file = event.target.files[0];
    this.enableUploadBtn = false;
    setTimeout(() => {
      this.enableUploadBtn = true;
    }, 100);
  }

  constructor(
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private fuelCardService: FuelcardService,
    public awserviceProvider: AwsService

  ) { }

  ngOnInit() {
    this.getAllFuelCardCredit();
  }

  async getAllFuelCardCredit() {
    const limit = 100;  // Set the limit for records per request
    let offset: number = 0;  // Start with 0 for the first page
    this.filteredFuelCardCredit = []// Initialize tempData to store fetched data
    this.spinnerService.show();  // Show spinner while loading data

    try {
      // Loop until nextToken becomes null (no more pages)
      //do {
      // Fetch data from API, starting with null nextToken for the first page
      const data = (await this.fuelCardService.getAllFuelCardCredit(offset, limit));
      console.log("Fetched Page Data:", data);

      // Append the fetched records to tempData
      this.filteredFuelCardCreditList = [...this.filteredFuelCardCreditList, ...data.items];
      console.log(`Total records fetched so far: ${this.filteredFuelCardCreditList.length}`);
      // if (data && data.length === Number(limit)) {
      //   offset += limit;
      // }
      // else {
      //   offset = 0;
      // }
      // Update nextToken for the next iteration (will be null if no more pages)
      // nextToken = data.nextToken;
      // console.log("Next Token:", nextToken, this.filteredFuelCardCreditList);

      this.filteredFuelCardCredit = [...this.filteredFuelCardCredit, ...this.filteredFuelCardCreditList];

      //} while (offset !== null);  // Continue as long as there's a nextToken
      this.initializeFilterData();
      this.spinnerService.hide();
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.spinnerService.hide();  // Hide the spinner after the process
    }

  }

  initializeFilterData() {
    this.rnNumberFilterData = [];
    this.cardNoFilterData = [];

    // Populate the filter data arrays
    for (const item of this.filteredFuelCardCreditList) {
      const rn = item && item.rn_number ? item.rn_number : null;
      const card = item && item.fuelcard && item.fuelcard.card_number ? item.fuelcard.card_number : null;

      this.pushIfValid(this.rnNumberFilterData, rn);
      this.pushIfValid(this.cardNoFilterData, card);
    }
    // Update dropdown data with proper change detection
    const updateDropdownData = () => {
      this.rnNumberFilterData = [...this.rnNumberFilterData];
      this.cardNoFilterData = [...this.cardNoFilterData];
    };
    updateDropdownData();
  }

  private pushIfValid(arr: any[], value: any): void {
    if (value != null && !arr.includes(value)) {
      arr.push(value);
    }
  }


  onFilterChange() {
    this.filteredFuelCardCredit = this.filteredFuelCardCreditList.filter(vehicle => {
      // // Helper function to check if a value matches the filter
      const matchesFilter = (filter: any[], value: any) =>
        !filter.length || filter.includes(value);

      this.rnNumberFilterData = [...this.rnNumberFilterData];
      this.cardNoFilterData = [...this.cardNoFilterData];

      // Checking if the vehicle matches all filters
      const matchRNNo = matchesFilter(this.rnNumberFilterModel, vehicle.rn_number);
      const matchCardNo = matchesFilter(this.cardNoFilterModel, vehicle.fuelcard.card_number);

      // Return true only if all criteria match
      return (
        matchRNNo &&
        matchCardNo
      );

    });
  }

  isInvalid(str) {
    if (str == 'undefined' || str == null || str.length < 1)
      return true;
    else
      return false;
  }

  uploadFuelCard() {
    if (this.file == undefined) {
      return;
    }

    this.statusList = [];
    this.uploadList = [];
    this.progresspercent = 0;
    this.uploadStatus = 1;
    this.displayValue = 0;

    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var worksheet = workbook.Sheets["data"];
      var sheet = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      this.sheetlength = sheet.length;
      this.startProcess(sheet);
    }
    fileReader.readAsArrayBuffer(this.file);
    this.uploadStatus = 1;
  }

  //After reading insert the record 
  async startProcess(sheet) {
    var rnNumberSet = new Set();
    for (const dict of sheet) {

      var s_no = String(dict["S.No"]).trim();
      var rn_number = String(dict["Employee RN Number"]).trim();
      var loading_value = String(dict["Loading Value"]).trim();

      const excelDateToJSDate = (serial) => {
        // Excel's base date is 1900-01-01, so we adjust it by subtracting 25569 (Excel to Unix date shift)
        const jsDate = new Date((serial - 25569) * 86400 * 1000); // Convert to JavaScript Date

        // Format the date as yyyy-mm-dd
        const formattedDate = jsDate.toISOString().split('T')[0];

        return formattedDate;
      }

      const rcdate = excelDateToJSDate(dict['Loading Date']);
      var loading_date = rcdate;


      var carData = {
        rn_number: rn_number,
        loading_value: String(loading_value),
        loading_date: loading_date
      }

      console.log(carData);


      var errorText = ""

      if (this.isInvalid(carData.rn_number)) {
        errorText = errorText + 'Invalid RN Number :: '
      } else {
        if (!carData.rn_number.startsWith('RN') || (carData.rn_number.length < 7)) {
          errorText = errorText + 'Invalid RN Number :: '
        } else {
          const isRNNumberAvailable = await this.isRNNumberAvailable(carData.rn_number)
          if (isRNNumberAvailable) {
            rnNumberSet.add(carData.rn_number);
            carData['rnc_user_id'] = isRNNumberAvailable[0].id;
            carData['rnc_user_name'] = isRNNumberAvailable[0].name;
            carData['email'] = isRNNumberAvailable[0].email_address;
            const assignedCar = await this.awserviceProvider.filterRnExistCar(carData.rn_number);
            const fuelcard = assignedCar.find(car => car.status === 'ASSIGN' && car.fuel_card_id && String(car.ex_data || '').toLowerCase().includes('office'));
            if (assignedCar.length && fuelcard) {
              carData['fuel_card_id'] = fuelcard.fuel_card_id;
            } else {
              errorText = errorText + 'Fuel Card Number ' + carData.rn_number + ' does not exist :: '
            }
          } else {
            errorText = errorText + 'RN Number ' + carData.rn_number + ' does not exist :: '
          }
        }
      }

      if (this.isInvalid(carData.loading_value)) {
        errorText = errorText + 'Invalid Loading Value :: '
      }

      if (this.isInvalid(carData.loading_date)) {
        errorText = errorText + 'Invalid Loading Date :: '
      }


      if (carData.loading_date) {
        var dateSplitArr = carData.loading_date.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Loading Date :: '
        }
      }


      if (errorText.length > 0) {
        // console.log("----------" + errorText)
        this.statusList.push({ line_no: s_no, status: 'Error', error: errorText });
        this.displayValue = 1;
        this.uploadStatus = 3;
      } else {
        this.uploadList.push(carData)
        this.progressIncrement();
      }

    }

    if (this.statusList.length == 0 && this.uploadList.length > 0) {
      // console.log('inside if');
      for (var i = 0; i < this.uploadList.length; i++) {
        var item = this.uploadList[i];
        this.OnSaveFuelcardCredit(item, i);
      }
    }
  }

  async isRNNumberAvailable(rn_number) {
    // console.log("Searching RN Number in RNC Users.....", rn_number);
    var isRNNumberAvailable = await this.awserviceProvider
      .rnUserFilter(rn_number)
      .then(result => {
        if (result.length === 0) {
          return null;
        } else {
          if (result.length > 0) {
            console.log("RN Number Found in RNC Users.....", rn_number);
          }
          return result;
        }
      })
      .catch(err => {
        console.log("err", err);
      });
    // console.log('----- isRNNumberAvailable: ' + isRNNumberAvailable);
    return isRNNumberAvailable;
  }

  closeModal() {
    this.closeuploadModalBtn.nativeElement.click();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  async OnSaveFuelcardCredit(value, i) {
    const fuelcardcredit: any = await this.fuelCardService.createFuelCardCredit(value);
    let getcardNumber: any;
    if (fuelcardcredit && fuelcardcredit.fuel_card_id) {
      getcardNumber = await this.fuelCardService.findFuelCardByCardId(fuelcardcredit.fuel_card_id);
    }
    if (getcardNumber && getcardNumber.length > 0 && getcardNumber[0].card_number) {
      value['fuel_card_no'] = getcardNumber[0].card_number;
    } else {
      value['fuel_card_no'] = '';
    }
    this.triggerEmail(value);
    if (i == this.uploadList.length - 1) {
      this.closeModal();
    }
  }

  progressIncrement() {
    if (this.cnt == this.sheetlength) {
      this.uploadStatus = 2;
    }

    this.progresspercent = this.cnt * 50 / this.sheetlength;
    this.cnt++;
  }

  resetFile() {
    this.uploadFile.nativeElement.value = null;
    this.file = undefined;
    this.enableUploadBtn = false;
    this.uploadStatus = 0;
  }

  navigateToNewFuelCardCredit() {
    this.router.navigate(['/pages/fuel-card-credit/add']);
  }

  editRow(creditdata: any) {
    this.fuelCardService.setFuelCardCreditData(creditdata);
    this.router.navigate(['/pages/fuel-card-credit/edit']);
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return 'fa fa-sort-desc';
      }
      else {
        return 'fa fa-sort-asc';
      }
    }
    else {
      return 'fa fa-sort';
    }
  }

  triggerEmail(payload: any) {
    this.fuelCardService.triggercreditEmail(payload);
  }

}
